import { changeProductQuantity } from "./api";

export function account() {
    let html = $("html");
    let group = $(".group");
    let summary = $(".summary");
    let preloader = $(".preloader");
    let woocommerce_checkout = $("form.woocommerce-checkout");

    $(window).on("resize", function() {
        checkSizes()
    })

    setInterval(function(){
        if(woocommerce_checkout.hasClass("processing")) {
            preloader.addClass("show");
        } else {
            preloader.removeClass("show");
        }

        checkSizes()

    },10);

    woocommerce_checkout.css("min-height", summary.outerHeight() + 100 +"px");

    const req_inputs = ['billing_first_name','billing_last_name','billing_email','billing_phone','rules'];
    const company_inputs = ['company_name','company_register_number','company_address','company_postcode','company_bank_name','company_bank_swift','company_bank_account'];
    const shipping_inputs = ['billing_address_1','billing_address_2','billing_city','billing_postcode'];

    setTimeout(function() {

        $('input:-webkit-autofill').each( function() {
            let me = $(this)
            me.parent().addClass('focus')
        });

        $('.field input, .form-row input').each( function() {
            let me = $(this)

            if(me.val() !== "") {

                me.parent().addClass('focus')

                let name = me.attr('name');

                if(name == 'billing_phone') {
                    let value = me.val();
                    let mobile = value.replace(/ /g,'');

                    if(value.slice(0,1)=='+'){
                        mobile = mobile.substring(4)
                    }

                    me.val(mobile)
                }

            }

            // Only numbers
            if(me.attr('id') === 'company_postcode' ||
                me.attr('id') === 'company_register_number' ||
                me.attr('id') === 'billing_phone' ||
                me.attr('name') === 'billing_postcode' ||
                me.attr('name') === 'billing_phone') {
                me.ForceNumericOnly();
            }

            if(me.attr('id') === 'company_postcode' || me.attr('name') === 'billing_postcode') {

                me.focus(function() {
                    me.val("LV-")
                });

                me.focusout(function() {
                    if (me.val() == "") {
                        me.val("")
                    }
                });

                me.on('select keydown contextmenu mousedown drop', function(e) {
                    if(e.type == 'keydown' && this.selectionStart == 0 && this.selectionEnd == 0) {
                        this.setSelectionRange(3, 3);
                    }
                    if((e.keyCode == 37 && (this.selectionStart == 3 || e.ctrlKey)) || (e.keyCode == 36) ||
                        (e.keyCode == 8 && this.value.length == 3)|| (e.keyCode == 46 && this.selectionStart == 0) || e.type == 'drop') {
                        e.preventDefault();
                    }
                    if(this.selectionStart == 0 &&
                        this.selectionStart != this.selectionEnd) {
                        this.setSelectionRange(3, this.selectionEnd);
                    }
                });

            }

        });

        $('.form-row label').each( function() {
            let me = $(this)
            me.removeClass("screen-reader-text")
        });

        $('.form-row input').each( function() {
            let me = $(this)

            if(me.val() != "") {
                me.parent().parent().addClass('focus')
            }

        });

    },0)

    $(".woocommerce .woocommerce-checkout .group .input-tabs a").on("click tap", function() {
        let me = $(this)
        me.addClass("active").siblings().removeClass("active")
        let company_field = $(".woocommerce .woocommerce-checkout .group fieldset p.form-row-company");

        if(me.hasClass("show-company")) {
            company_field.stop().fadeIn("fast");
        } else {
            company_field.stop().hide();
        }

        checkSizes()

        return false;

    });

    //Validate info
    $("#billing .approve-fields .button_2").on("click tap", function() {
        let err = 0;
        let show_company = $(".woocommerce .woocommerce-checkout .group .input-tabs a.show-company");

        $.each(req_inputs, function( ind,id ) {
            let input = $("#"+id);
            let form_row = input.parent().parent();

            if(id == "billing_phone") {
                let value = input.val();
                let mobile = value.replace(/ /g,'');

                if(value.slice(0,1)=='+'){
                    mobile = mobile.substring(4)
                }

                input.val(mobile)
            }

            if(id == "rules") {
                if(!input.is(":checked")) {
                    form_row.addClass("error");
                    err++;
                } else {
                    form_row.removeClass("error");
                }
            } else {

                if(input.val() == "") {
                    form_row.addClass("error");
                    err++;
                } else {

                    if(id == "billing_email") {
                        let validate_email = validateEmail(input.val());

                        if(!validate_email) {
                            form_row.addClass("error");
                            err++;
                        } else {
                            form_row.removeClass("error");
                        }

                        console.log(validate_email)
                    } else {
                        form_row.removeClass("error");
                    }

                }
            }

        });

        if(show_company.hasClass("active")) {

            $.each(company_inputs, function( ind,id ) {
                let input = $("#"+id);
                let form_row = input.parent().parent();

                if(input.val() == "") {
                    form_row.addClass("error");
                    err++;
                } else {
                    form_row.removeClass("error");
                }
            });


            $('input[name="company_register_number"]').removeClass('error')
            if ($('input[name="company_register_number"]').val().length > 14 || $('input[name="company_register_number"]').val().length < 8){
                $('input[name="company_register_number"]').parent().parent().addClass('error')
                err++
            }

            $('input[name="company_vat_number"]').removeClass('error')
            const vatPattern = /^[A-Za-z]{2}\d{11}$/;
            if ($('input[name="company_vat_number"]').val() != '' && !vatPattern.test($('input[name="company_vat_number"]').val()) ){
                $('input[name="company_vat_number"]').parent().parent().addClass('error')
                err++
            }



        } else {
            $.each(company_inputs, function( ind,id ) {
                let input = $("#"+id);
                let form_row = input.parent().parent();
                form_row.removeClass("error focus");
                input.val("");
            });
        }

        if(err < 1) {
            console.log("approve fields");

            html.addClass("billing-validated");

            if(!html.hasClass("is-shipping")) {
                console.log("! is-shipping. #payment add active group")
                $("#payment").addClass("active-group").siblings().removeClass("active-group");
            } else {
                console.log("is-shipping. #shipping_address add active group")
                $("#shipping_address").addClass("active-group").siblings().removeClass("active-group");
            }

            checkSizes()

        } else {
            html.removeClass("billing-validated");
            console.log(err)
        }

        return false;
    });

    //Validate shipping
    $("#shipping_address .approve-fields .button_2").on("click tap", function() {

        let err = 0;

        $.each(shipping_inputs, function( ind,id ) {
            let input = $("#"+id);
            let form_row = input.parent().parent();

            if(input.val() == "") {
                form_row.addClass("error");
                err++;
            } else {
                form_row.removeClass("error");
            }
        });

        if(err < 1) {
            console.log("approve shipping fields");
            html.addClass("shipping-validated");

            if(html.hasClass("shipping-validated")) {
                console.log("shipping validated. #payment add active group")
                $("#payment").addClass("active-group").siblings().removeClass("active-group");
            }

        } else {
            console.log("nav shipping")
            html.removeClass("shipping-validated");
        }

        return false;
    });

    group.on("click", function() {
        let me = $(this);

        if(me.attr("id") == "billing" && html.hasClass("billing-validated")) {
            me.addClass("active-group").siblings().removeClass("active-group");
            checkSizes()
        }

        if(me.attr("id") == "shipping_address" && html.hasClass("shipping-validated")) {
            me.addClass("active-group").siblings().removeClass("active-group");
            checkSizes()
        }

    })

    $(".single-user-order .head").on("click tap", function() {
        let me = $(this)
        let parent = me.parent()
        let body = parent.find(".body")
        let wrapper = body.find(".body-wrapper")
        let body_h = wrapper.outerHeight()

        me.toggleClass("active")

        if(me.hasClass("active")) {
            body.css("height",body_h+"px");
            parent.addClass("show-details");
            //hide siblings
            parent.siblings().removeClass("show-details")
            parent.siblings().find(".body").css("height","0px")
            parent.siblings().find(".head").removeClass("active")
        } else {
            parent.removeClass("show-details");
            body.css("height","0px");
        }

    });

    $(document).on('change', '.change_q', function(){
        let me = $(this)
        let quantity = me.val()
        let key  = me.data("key")
        let max_q = me.attr("max")

        if(max_q && quantity > 0) {

            if(quantity <= max_q) {
                changeProductQuantity(me,key,quantity,max_q);
            } else {
                me.val(me.attr("value"))
            }

        }

        return false;

    });

    $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
            return false;
        }
    });

}

function checkSizes() {
    let H = $(window).height()
    let W = $(window).width()
    let woo_h = $(".woocommerce").outerHeight();
    let a_h = $(".account-header").outerHeight();
    let a_f = $(".account-footer").outerHeight();
    let content_H;

    if(woo_h) {
        content_H = a_h + woo_h + a_f + 80;
    } else {
        content_H = a_h + $(".account-content").outerHeight() + a_f + 80;
    }

    // console.log(content_H, H);

    if (content_H < H) {
        $(".account-footer").addClass('bottom');
    } else {
        $(".account-footer").removeClass('bottom');
    }

    if(W < 1280) {
        
        let summary_h = $(" .summary").outerHeight();
        let table_clone_html = $(".woocommerce .woocommerce-checkout .summary .totals").html();

        $(".summary-mobile").html(table_clone_html);

        $(".woocommerce .woocommerce-checkout").css("padding-top",summary_h +20 + "px");

    } else {
        $(".woocommerce .woocommerce-checkout").css("padding-top","0px");
    }
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

// Numeric only control handler
$.fn.ForceNumericOnly = function() {
    return this.each(function() {
        $(this).keydown(function(e) {
            var key = e.charCode || e.keyCode || 0;
            // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
            // home, end, period, and numpad decimal
            return (
                key == 8 ||
                key == 9 ||
                key == 13 ||
                key == 46 ||
                key == 110 ||
                key == 190 ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105));
        });
    });
};